<section class="section" style="height: 70vh" #exe id="exe">
    <div class="shell shell--size-3" style="height: 100%">
        <br />
        <div class="row chart" id="chartSize">
            <div class="col">
                <!-- <div class="chart__head hidden-xs"> -->
                <div class="chart__head">
                    <div class="chart__head-content">
                        <h6>Trade Executions</h6>

                        <!-- <h5>Cummulative Performance Gain as at 30 November 2023</h5> -->
                        <span style="font-size: x-small" *ngIf="mobile">UPDATED:
                            {{lastDate}}</span><br />
                        <span style="font-size: small" *ngIf="!mobile">UPDATED:
                            {{lastDate}}</span><br />
                        <!-- <span>Last Updated: {{updateRecent}}</span> -->
                    </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
            </div>
            <div *ngIf="!mobile" class="col legendGrad legendShadow" id="legendExe">
                <div id="legendItems">
                    <div class="row margBottomLegend" style="display: none;">
                        <div class="col">AGR - 2021 (Traded Gain)</div>
                        <div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                    </div>
                    <div class="row margBottomLegend">
                        <div class="col">AGR +/- (Since Oct 2022)</div>
                        <div class="col">
                            <span id="unrealised" *ngIf="agrGAIN >= 0" style="color: green">+{{agrGAIN}}%</span>
                            <span id="unrealised" *ngIf="agrGAIN < 0" style="color: red">{{agrGAIN}}%</span>
                        </div>
                    </div>
                    <div class="row margBottomLegend">
                        <div class="col">Net Asset Value +/-</div>
                        <div class="col"><span id="netasset"><span
                                    *ngIf="netAssetPos">+</span>{{netAsset}}%</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mobile" class="row legendGrad legendShadow" id="legendExe">
            <div id="legendItems">
                <div class="row margBottomLegend" style="display: none;">
                    <div class="col">AGR - 2021 (Traded Gain)</div>
                    <div class="col-auto legendPadMob"><span id="tGain"><span
                                *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                </div>
                <div class="row margBottomLegend">
                    <div class="col">AGR +/- (Since Oct 2022)</div>
                    <div class="col-auto legendPadMob">
                        <span id="unrealised" *ngIf="agrGAIN >= 0" style="color: green">+{{agrGAIN}}%</span>
                        <span id="unrealised" *ngIf="agrGAIN < 0" style="color: red">{{agrGAIN}}%</span>
                    </div>
                </div>
                <div class="row margBottomLegend">
                    <div class="col">Net Asset Value +/-</div>
                    <div class="col-auto legendPadMob"><span id="netasset"><span
                                *ngIf="netAssetPos">+</span>{{netAsset}}%</span></div>
                </div>
            </div>
        </div>
        <br />
        <div class="row chart" style="height: 70vh">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart"
                style="height: 70vh">
                <div id="exeContainer" class="textCenter">
                </div><!-- /.chart__body -->
            </div>
        </div>
    </div><!-- /.shell -->
</section>